/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 16/01/2014
 * Time: 16:05
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('WidgetView', ["$sce","$filter",
        function ($sce,$filter) {
            var WidgetView = function (widget,index,loadSub, domainView,pWidgetView) {
                this.index = index;
                this.domainView = domainView;
                this.pWidgetView = pWidgetView !== undefined ? pWidgetView : null;
                this.x = 0;
                this.y = 0;
                this.width = 4;
                this.height = 7;
                this.effect = null;
                this.widgetsView = [];
                this.isGalery = false; //view only
                this.isDefault = false;//view only
                this.displaySelectorLarge = true;//view only
                this.defaultCardEffect = 'f0_card'
                //SUBOBJECT
                this.img = null;
                this.type = null;  //text / object / fullscreen-offer / default-offer / video / title
                this.object = null;
                this.objectType = null;
                this.spHtml = false;
                this.blockBgColor = null;
                this.shadowColor = null;
                this.fontColor = null;
                this.blockPos = "mid";
                this.spImg = false;
                this.isActive = false;
                this.textHtml = null;
                this.visible = false;
                this.imgUrl =null;
                if (widget !== undefined && widget != null)
                    this.loadDataFrom(widget,loadSub);
            };
            WidgetView.prototype.loadItems = function (items) {
                //remove service/product/cure/loyalty if isOnHome : False
                if (this.widgetsView)
                    for (var i = 0; i < this.widgetsView.length; i++)
                        switch (this.widgetsView[i].objectType) {
                            case "service":
                            case "product":
                            case "cure":
                                if (this.widgetsView[i].object && !this.widgetsView[i].object.isOnHome)
                                {
                                    this.removeWidgetView(this.widgetsView[i]);
                                    i--;
                                }
                                break;
                        }
                // loadItems from item list based on service/product/cure/loyalty/isOnHome : true
                for (var i = 0; i < items.length; i++) {
                    if (!this.hasObject(items[i].item))
                    {
                        var widgetView = new WidgetView(null,i,false, this.domainView,this);
                        widgetView.setObject(items[i].item, items[i].type);
                        this.widgetsView.push(widgetView);
                    }
                }
            };
            WidgetView.prototype.hasObject = function (object) {
                if (this.widgetsView)
                    for (var i = 0; i < this.widgetsView.length; i++)
                        if (this.widgetsView[i].object==object)
                            return true;

                return false;
            }
            WidgetView.prototype.loadDataFrom = function (widget,loadSub) {
                this.displaySelectorLarge = false;//not new

                this.x = widget.x;
                this.y = widget.y;
                this.width = widget.width;
                this.height = widget.height;
                if (this.domainView && this.domainView.ad.view.isOnMobile)//optimize display on mobile
                {
                    this.height = Math.round(this.height*4/this.width);//proportion
                    this.width = 4;
                }
                if (widget.imgId) {
                    this.img = this.domainView.getImagesViewById(widget.imgId);
                }
                if (widget.type)
                    this.type = widget.type;
                this.effect = widget.effect;
                if (widget.blockBgColor)
                    this.blockBgColor = widget.blockBgColor;
                if (widget.shadowColor)
                    this.shadowColor = widget.shadowColor;
                if (widget.fontColor)
                    this.fontColor = widget.fontColor;
                if (widget.blockPos)
                    this.blockPos = widget.blockPos;
                if (widget.textHtml && widget.textHtml != "")
                    this.textHtml = widget.textHtml;
                this.imgUrl = widget.imgUrl;
                if (widget.objectType && this.domainView) {
                    this.spHtml = widget.spHtml;
                    this.spImg = widget.spImg;
                    var object = null;
                    switch (widget.objectType) {
                        case "service":
                            object = this.domainView.getServiceViewById(widget.objectId);
                            break;
                        case "category":
                            object = this.domainView.getCategoryViewById(widget.objectId);
                            break;
                        case "product":
                            object = this.domainView.getProductViewById(widget.objectId);
                            break;
                        case "productCategory":
                            object = this.domainView.getProductCategoryViewById(widget.objectId);
                            break;
                        case "cure":
                            object = this.domainView.getCureViewById(widget.objectId);
                            break;
                        case "cureCategory":
                            object = this.domainView.getCureCategoryViewById(widget.objectId);
                            break;
                        case "gift":
                            object = widget.object;
                            break;
                    }
                    if (object)
                        this.setObject(object, widget.objectType, false);
                }



                var subWidget;
                if (widget.widgets && loadSub)
                {
                    this.widgetsView = [];
                    for (var i = 0; i < widget.widgets.length; i++) {
                        subWidget = new WidgetView(widget.widgets[i],i,false, this.domainView,this);
                        subWidget.pWidgetView = this;
                        if (subWidget.objectType!="object" || subWidget.object)//object must has been instanciate
                            this.widgetsView.push(subWidget);
                    }
                }
                this.isGalery = this.widgetsView.length > 1;
                this.updateParentType();
            };
            WidgetView.prototype.changeWidgetPosition = function (widgetView, indexTarget) {
                //Change the category position
                // This : parentCategory
                // serviceView : service to move to indexTarget

                var index = this.widgetsView.indexOf(widgetView);
                if (indexTarget != -1 && index != -1 && indexTarget <= this.widgetsView.length) {
                    this.widgetsView.splice(index, 1); //remove it
                    if (indexTarget == this.widgetsView.length)
                        this.widgetsView.push(widgetView);
                    else
                        this.widgetsView.splice(indexTarget, 0, widgetView);//insert
                }

            };
            WidgetView.prototype.setVideo = function (src) {
                var index = src.indexOf("watch?v=");
                var embed = null;
                var id = null;
                var imgVid = null;
                if (index != -1)
                    id = src.substring(index + 8);
                else {
                    index = src.indexOf("embed/");
                    if (index != -1)
                        id = src.substring(index + 6);
                    else {
                        index = src.indexOf("youtu.be/");
                        if (index != -1)
                            id = src.substring(index + 9);

                    }
                }
                if (id) {
                    index = id.indexOf("/");
                    if (index != -1)
                        id = id.substring(0, index);
                    index = id.indexOf("&");
                    if (index != -1)
                        id = id.substring(0, index);
                    imgVid = "https://img.youtube.com/vi/" + id + "/hqdefault.jpg";
                    this.imgUrl = imgVid;
                    embed = "https://www.youtube.com/embed/" + id;
                    this.textHtml = '<img class="ta-insert-video" src="' + imgVid + '" ta-insert-video="' + embed + '" contenteditable="false" allowfullscreen="true" frameborder="0" style="width: 100%;height=100%">';
                }

            }
            WidgetView.prototype.setType = function (type, isParent) {
                this.displaySelectorLarge = false;
                if (isParent) {
                    var widgetView = new WidgetView(null,this.widgetsView.length,false, this.domainView, this);
                    widgetView.setType(type, false);
                    this.widgetsView.push(widgetView);
                    this.isGalery = this.widgetsView.length > 1;
                    this.type = type;
                    if (type=="title")
                    {
                        this.width = 12;
                        this.height = 2;
                    }
                    if (type=="text")
                        this.width = 6;
                    this.updateParentType();
                }
                else {
                    this.type = type
                }
            }
            WidgetView.prototype.setImage = function (img, isParent) {
                this.displaySelectorLarge = false;
                if (isParent) {
                    var widgetView = new WidgetView(null,this.widgetsView.length,false, this.domainView,this);
                    widgetView.setImage(img, false);
                    this.widgetsView.push(widgetView);
                    this.isGalery = this.widgetsView.length > 1;
                    this.updateParentType();
                }
                else {
                    if (this.type=='object')
                        this.spImg = true;
                    else
                        this.type = "image";
                    this.img = img;
                }
            };
            WidgetView.prototype.removeWidgetView = function (widgetView) {
                var index = this.widgetsView.indexOf(widgetView)
                if (index != -1)
                    this.widgetsView.splice(index, 1);
            }

            WidgetView.prototype.setObject = function (object, objectType, isParent) {
                this.displaySelectorLarge = false;

                if (isParent) {
                    var widgetView = new WidgetView(null,this.widgetsView.length,false, this.domainView,this);
                    widgetView.setObject(object, objectType, false);
                    this.widgetsView.push(widgetView);
                    this.isGalery = this.widgetsView.length > 1;
                    if (!this.isGalery)
                    {
                        this.shadowColor = "black";
                        this.fontColor = "white";
                        this.effect = this.defaultCardEffect;
                    }
                    this.updateParentType();
                }
                else {
                    this.type = 'object';
                    this.object = object;
                    this.objectType = objectType;
                    if (object) {
                        if (this.object.imageDisplayed && !this.spImg)
                            this.img = this.object.imageDisplayed;
                        if (!this.spHtml)
                            this.textHtml = this.getAutoText(object,objectType);
                        if (this.objectType=="gift")
                            this.imgUrl ="/img/exemplebon.svg";

                    }
                }


            };
            WidgetView.prototype.getAutoText = function (object,objectType) {
                var textHtml ="";
                switch (objectType) {
                    case "service":
                    case "product":
                    case "cure":
                        if (this.pWidgetView && this.pWidgetView.type=="default-offer")
                            textHtml = '<h2>' + this.object.label + '</h2>';
                        else
                            textHtml = '<h2 style="text-align: center;">' + this.object.label + '</h2>';
                        if (this.object.description && this.object.description!='' && this.pWidgetView)
                            if(this.pWidgetView.type=="default-offer")
                                if (this.object.description.indexOf("<p>")==0)
                                    textHtml += this.object.description;
                                else
                                    textHtml += '<p>'+ this.object.description + '</p>';

                        break;
                    case "category":
                    case "productCategory":
                    case "loyaltyCardCategory":
                    case "cureCategory":
                        if (this.pWidgetView && this.pWidgetView.type=="default-offer")
                            textHtml = '<h2>' + this.object.label + '</h2>';
                        else
                            textHtml = '<h2 style="text-align: center;">' + this.object.label + '</h2>';
                        break;
                    case "gift":
                        var tag = "div";
                        if (this.pWidgetView && (this.pWidgetView.type=="default-offer" || this.pWidgetView.type=="fullscreen-offer"))
                            tag = "h2";
                        var style = "";
                        if (this.pWidgetView && this.pWidgetView.type=="fullscreen-offer")
                            var style = "text-align: center;";
                        if (object == "delivery")
                            textHtml = '<'+tag+' style="'+style+'">Un chèque cadeau livré chez vous ?</'+tag+'>';
                        if (object == "mailPrint")
                            textHtml = '<'+tag+' style="'+style+'">Un chèque cadeau imprimable ?</'+tag+'>';
                        if (object == "mail")
                            textHtml = '<'+tag+' style="'+style+'">Un chèque cadeau envoyé par email ?</'+tag+'>';
                        break;
                }
                return textHtml;
            };
            WidgetView.prototype.updateParentType = function () {
                if (this.type!="title" && this.type!="text"&& this.type!="fullscreen-offer"&& this.type!="default-offer")
                {
                    if (this.widgetsView.length!=0)
                        this.type = this.widgetsView[0].type;
                    for (var i = 1; i < this.widgetsView.length; i++)
                        if (this.type !=this.widgetsView[i].type && this.type != "mixed")
                            this.type = "mixed";
                }
            };
            WidgetView.prototype.updateFromDefault = function (widgetView) {
                if (this.type!="title")
                {
                    this.effect = widgetView.effect;
                    this.blockBgColor = widgetView.blockBgColor;
                    this.fontColor = widgetView.fontColor;
                    this.shadowColor = widgetView.shadowColor;
                }
            };
            WidgetView.prototype.updateTextHtml= function () {
                if (!this.spHtml)
                    this.textHtml=this.getAutoText(this.object,this.objectType);
                if (this.widgetsView)
                    for (var i = 0; i < this.widgetsView.length; i++)
                        this.widgetsView[i].updateTextHtml();
            };

            WidgetView.prototype.onUpdateTextHtml = function () {
                if (this.type=="object")
                    this.spHtml = (this.textHtml!=this.getAutoText(this.object,this.objectType));
            };
            WidgetView.prototype.getObjectResource = function () {
                var resource = {};
                resource.x = this.x;
                resource.y = this.y;
                resource.width = this.width;
                resource.height = this.height;
                if (this.img)
                    resource.imgId = this.img.id;
                resource.effect = this.effect;
                resource.type = this.type;
                resource.blockBgColor = this.blockBgColor;
                resource.fontColor = this.fontColor;
                resource.shadowColor = this.shadowColor;
                resource.spHtml = this.spHtml;
                resource.spImg = this.spImg;
                resource.blockPos = this.blockPos;
                resource.imgUrl = this.imgUrl;
                if (this.object)
                {
                    if (typeof this.object !== "string" && this.object.getModel())
                        resource.objectId = this.object.getModel().id;
                    else
                        resource.object = this.object;
                    resource.objectType = this.objectType;
                }
                resource.widgets = [];
                if (this.widgetsView)
                    for (var i = 0; i < this.widgetsView.length; i++)
                        resource.widgets.push(this.widgetsView[i].getObjectResource());
                resource.textHtml = this.textHtml;
                return resource;
            };

            return WidgetView;
        }]);


// WEBPACK FOOTER //
// ./js/services/customerSite/views/WidgetView.js